import { I18n } from '@calendly/i18n'

import { Summary } from './summary'
import { AccordionPanel } from '../../../components/accordion'
import { InviteeForm } from '../../components/invitee_form'
import { useWorkflows } from '../use_workflows'

export const InviteeFormPanel = ({ isLocked, ...props }) => {
  const workflows = useWorkflows()

  return (
    <AccordionPanel
      titleId="invitee-form-label"
      title={I18n.t('publisher.event_type_editor.sections.more_options.invitee_form.title')}
      subheader={<Summary />}
      {...props}
    >
      <InviteeForm
        workflows={workflows.list || []}
        isLocked={isLocked}
      />
    </AccordionPanel>
  )
}
